var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyBenefits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.466,
    height: 115.746,
    viewBox: "0 0 166.466 115.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16556",
    "data-name": "Path 16556",
    d: "M9.9,49.074h142.66a9.931,9.931,0,0,1,9.9,9.9V150.92a9.93,9.93,0,0,1-9.9,9.9H9.9a9.931,9.931,0,0,1-9.9-9.9V58.974a9.93,9.93,0,0,1,9.9-9.9Zm112.075,71.364a12.575,12.575,0,0,1,6.959,2.089,12.643,12.643,0,1,1,0,21.112,12.644,12.644,0,1,1-6.959-23.2Zm-105-5.145h44.5V126h-44.5Zm0,19.605h68.98V145.6H16.977Z",
    transform: "translate(2 -47.074)",
    fill: "none",
    stroke: "#2c53bb",
    strokeWidth: 4,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBenefits);
export default __webpack_public_path__ + "static/media/my-benefits.8417058bd71f0589a828fc9e1b403f96.svg";
export { ForwardRef as ReactComponent };